exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tag {\n  font-size:small;\n  padding: 0.3ex;\n  padding-left:1ex;\n  padding-right:1ex;\n  border: thin solid silver;\n  margin: 0.5ex;\n  border-radius: 8px;\n  font-weight: bold;\n  background-color: silver;\n  display: inline-block;\n  cursor: pointer\n}\n\n.tag.primary {\n  background-color: #BCEDAF;\n}\n\n.tag.secondary {\n  background-color: lightsalmon;\n}\n\n.number {\n  display: inline-block;\n  width:1em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/tag-sort/tag-sort.component.css
// module id = 407
// module chunks = 0